'use client';

import { __awaiter, __generator, __assign, __spreadArray } from '../../_virtual/_tslib.js';
import React__default, { forwardRef, useState, useImperativeHandle } from 'react';
import UploadIcon from '../../Images/UploadIcon/index.js';
import { ELanguage } from '../../Utils/constants.js';
import { uploadFile, validateFile } from '../service.js';
import { UploadCV, ErrorMsg } from '../Styled.css.js';
import { DEFAULT_ALLOW_FILES_EXT, DEFAULT_LIMIT_FILE_SIZE, EApplyType } from '../type.js';
import LoadingIcon from '../../Images/LoadingIcon/index.js';

var UploadFile = function (_a, ref) {
    var accessToken = _a.accessToken, lang = _a.lang, baseUrl = _a.baseUrl, t = _a.t, setApplyJobInfo = _a.setApplyJobInfo, applyJobInfo = _a.applyJobInfo, userId = _a.userId, jobId = _a.jobId;
    var _b = useState(false), isDrag = _b[0], setIsDrag = _b[1];
    var _c = useState(false), isError = _c[0], setIsError = _c[1];
    var _d = useState(), errorMes = _d[0], setErrorMes = _d[1];
    var _e = useState(false), isUpload = _e[0], setIsUpload = _e[1];
    var validateResume = function (uploadFileInfo) { return __awaiter(void 0, void 0, void 0, function () {
        var reponse, data, meta, tempApplyonCickInfo, lastAttachmentCVResume, newAttachment, indexNewAttachmentResume, error_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    setIsUpload(true);
                    _k.label = 1;
                case 1:
                    _k.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, validateFile({
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            langCode: lang !== null && lang !== void 0 ? lang : ELanguage.VI,
                            file: uploadFileInfo,
                            baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                            userId: userId,
                            jobId: jobId
                        })];
                case 2:
                    reponse = _k.sent();
                    if (reponse && reponse.data) {
                        data = reponse.data, meta = reponse.meta;
                        if (((_a = data.attributes) === null || _a === void 0 ? void 0 : _a.spam) === false) {
                            tempApplyonCickInfo = applyJobInfo;
                            lastAttachmentCVResume = (_b = tempApplyonCickInfo === null || tempApplyonCickInfo === void 0 ? void 0 : tempApplyonCickInfo.resumes) === null || _b === void 0 ? void 0 : _b.find(function (e) { return e.type === EApplyType.lastAttachment; });
                            newAttachment = {
                                allowSearchableDisplay: (_c = lastAttachmentCVResume === null || lastAttachmentCVResume === void 0 ? void 0 : lastAttachmentCVResume.allowSearchableDisplay) !== null && _c !== void 0 ? _c : 0,
                                value: !(lastAttachmentCVResume === null || lastAttachmentCVResume === void 0 ? void 0 : lastAttachmentCVResume.value) ? 'newAttachment' : lastAttachmentCVResume === null || lastAttachmentCVResume === void 0 ? void 0 : lastAttachmentCVResume.value,
                                text: (_d = uploadFileInfo.name) !== null && _d !== void 0 ? _d : '',
                                type: EApplyType.newAttachment,
                                enabled: true,
                                resumeFile: uploadFileInfo
                            };
                            indexNewAttachmentResume = (_e = tempApplyonCickInfo === null || tempApplyonCickInfo === void 0 ? void 0 : tempApplyonCickInfo.resumes) === null || _e === void 0 ? void 0 : _e.findIndex(function (e) { return e.type === EApplyType.newAttachment; });
                            if (typeof indexNewAttachmentResume === 'number' && indexNewAttachmentResume !== -1) {
                                (_f = tempApplyonCickInfo === null || tempApplyonCickInfo === void 0 ? void 0 : tempApplyonCickInfo.resumes) === null || _f === void 0 ? void 0 : _f.splice(indexNewAttachmentResume, 1);
                            }
                            setApplyJobInfo &&
                                setApplyJobInfo(__assign(__assign({}, tempApplyonCickInfo), { resumes: __spreadArray(__spreadArray([], ((_g = tempApplyonCickInfo === null || tempApplyonCickInfo === void 0 ? void 0 : tempApplyonCickInfo.resumes) !== null && _g !== void 0 ? _g : []), true), [newAttachment], false) }));
                            setErrorMes('');
                            setIsError(false);
                            setIsUpload(false);
                            return [2 /*return*/];
                        }
                        setErrorMes(meta === null || meta === void 0 ? void 0 : meta.message);
                        setIsError(true);
                    }
                    setErrorMes((_j = (_h = reponse === null || reponse === void 0 ? void 0 : reponse.meta) === null || _h === void 0 ? void 0 : _h.message) !== null && _j !== void 0 ? _j : '');
                    setIsUpload(false);
                    setIsError(true);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _k.sent();
                    setIsUpload(false);
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var doUploadFile = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var reponse, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!file)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, uploadFile({
                            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
                            langCode: lang !== null && lang !== void 0 ? lang : ELanguage.VI,
                            file: file,
                            baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : ''
                        })];
                case 2:
                    reponse = _a.sent();
                    if (reponse && reponse.data) {
                        setIsError(false);
                        return [2 /*return*/];
                    }
                    setIsError(true);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    setIsUpload(false);
                    console.error(error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useImperativeHandle(ref, function () {
        return {
            doUploadFile: function (file) {
                doUploadFile(file);
            }
        };
    }, []);
    var checkUploadFile = function (file) {
        var uploadFileInfo = file;
        // check file extensions
        if (!DEFAULT_ALLOW_FILES_EXT.includes(uploadFileInfo.type)) {
            // show error file type doesn't support
            setErrorMes(t('Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB'));
            setIsError(true);
            return;
        }
        // check file size
        if (uploadFileInfo.size > DEFAULT_LIMIT_FILE_SIZE) {
            // File is over 5MB
            setErrorMes(t('Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB'));
            setIsError(true);
            return;
        }
        // validate spam cv
        setErrorMes('');
        setIsUpload(false);
        validateResume(file);
        // do upload file and move to next tab
        // doUploadFile(uploadFileInfo)
    };
    var handleOnFileChange = function (e) {
        if (e.target.files !== null && e.target.files.length > 0) {
            checkUploadFile(e.target.files[0]);
        }
    };
    var handleOnDragEnter = function (e) {
        e.preventDefault();
        setIsDrag(true);
    };
    var handleOnDragLeave = function (e) {
        e.preventDefault();
        setIsDrag(false);
    };
    var handleOnDragOver = function (e) {
        e.preventDefault();
    };
    var handleOnDrop = function (e) {
        e.stopPropagation();
        e.preventDefault();
        setIsDrag(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            e.dataTransfer.clearData();
            checkUploadFile(e.dataTransfer.files[0]);
        }
    };
    return (React__default.createElement(UploadCV, { className: 'body__uploadCV', htmlFor: 'upload_cv', onDragEnter: handleOnDragEnter, onDragLeave: handleOnDragLeave, onDragOver: handleOnDragOver, onDrop: handleOnDrop, active: isDrag, disable: !applyJobInfo },
        React__default.createElement("input", { id: 'upload_cv', type: 'file', onChange: handleOnFileChange }),
        React__default.createElement("div", null,
            !isUpload ? React__default.createElement(UploadIcon, null) : React__default.createElement(LoadingIcon, null),
            t('Chọn hồ sơ từ máy của bạn')),
        React__default.createElement(ErrorMsg, { isPlaceholder: !isError },
            errorMes || t('Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB'),
            ".")));
};
var UploadFile$1 = forwardRef(UploadFile);

export { UploadFile, UploadFile$1 as default };
//# sourceMappingURL=UploadFile.js.map
